import { Injectable } from '@angular/core';
import { TutorialService } from '@services/tutorial.service';

@Injectable()
export class WoundsizeTutorialService extends TutorialService {
  getLocalStorageKey(): string {
    return 'woundsize-tutorial-dismissed';
  }
}
